import React from 'react'


import SvgClose from '../../../../../../components/SVG/Close'
import SvgPlus from '../../../../../../components/SVG/PlusCircle'
import SvgSelectAll from '../../../../../../components/SVG/SelectAll'

import ElementsGroup from '../../../../../../components/ElementsGroup'
import Button from '../../../../../../components/Button'

import { connect } from 'react-redux'
import SvgTrash from '../../../../../../components/SVG/Trash'
import { deleteVideosFromVideoList } from '../../../../../../store/ContentVideolists/actions'


const TableHeader_Buttons = ({
    addVideos,
    deleteVideosFromVideoList: deleteVideosFromVideoListInner,
    selectAll,
    toggleSelectedVideoAll,
    selected_video_all,
    selected_videolists,
}) => {
    const selectedVideosLength = Object.values(selected_video_all).length
    const deleteVideosFromVideoList = () => deleteVideosFromVideoListInner({
        videoListId: selected_videolists[0],
        ids_to_delete: selected_video_all
    })

    return (
        <div style={{ marginTop: -36, marginBottom: 18 }}>
            <ElementsGroup position="right">
                <div >
                    <Button
                        type="string"
                        disabled={!selectedVideosLength}
                        onClick={() => toggleSelectedVideoAll({ setAll: true, id_video: [] })}

                    >
                        <SvgClose size='xs' title="Очистить выбор" />Очистить выбор
                    </Button>

                    <br />

                    <Button

                        type="string"
                        disabled={!selectedVideosLength}
                        onClick={addVideos}
                    >
                        <SvgPlus size={`sm`} /> Добавить {`(${selectedVideosLength})`}
                    </Button>
                </div>
                <div>
                    <Button
                        type="string"
                        onClick={selectAll}
                        disabled={!selected_videolists.length}
                    >
                        <SvgSelectAll size={`xs`} /> Выделить все строки
                    </Button>
                    <br />
                    <Button
                        type="string"
                        onClick={deleteVideosFromVideoList}
                        disabled={!selected_video_all.length }
                    >
                        <SvgTrash />
                        {selected_videolists.length ? "Удалить из плейлиста" : "Удалить полностью"}
                    </Button>
                </div>
            </ElementsGroup>
        </div>
    )
}


const stateToProps = state => ({
    selected_video_all: state.videolists_all.selected_video,
    selected_videolists: state.videolists_all.selected,

})
const actionsToProps = {
}

export default connect(stateToProps, actionsToProps)(TableHeader_Buttons)